import { useEffect, useState } from "react";
import { useAuth } from "oidc-react";

const useFeatureConfig = () => {
  const [config, setConfig] = useState(null);
  const rootUrl = import.meta.env.VITE_BACKEND_API_ROOT_URL;
  const auth = useAuth();
  const accessToken = auth.userData?.access_token;

  useEffect(() => {
    if (!accessToken) return;
    fetch(`${rootUrl}FeatureConfig`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(setConfig)
      .catch(console.error);
  }, [accessToken]);

  return config;
};

export default useFeatureConfig;
